import { comparatorFilterParams } from './constants/filter-types';
import { camelCase } from 'lodash';

import { formatDate } from '../utils/common-utils';

const formatToFilterSchemaType = ( schemaType, values ) => {
    let formatted;
    switch( schemaType ){
        case 'date':
            const value = values[0];
            formatted = formatDate( value, 'YYYY-MM-DD' );
            break;
        case 'string':
            formatted = values[0];
            break;
        case 'array':
        default:
            formatted = values;
    }

    return formatted;
};

export const filterSchemaFormatter = ( column, values ) => {
    // Ag-Grid returns all filtered sets as arrays, even if they are single values
    // We want to convert the filters into the schema accepted by the API
    const filterTypeMap = {
        dateApproved: 'date',
        dmarcPolicy: 'array',
        dmarcSubDomainPolicy: 'array',
        domainGroups: 'array',
        domainType: 'string',
        lastDmarcPolicyChangeDate: 'date',
    };

    if( values.length > 0 ){
        return formatToFilterSchemaType( filterTypeMap[column], values );
    }

    return values;
};

export const clearFilter = () => {
    return { clear: true };
};


export const comparatorFilterMap = ( comparator ) => {
    const comparatorMap = {
        [comparatorFilterParams.greaterThan]: {
            queryParam: '[gte]',
            queryValue: ( value ) => {
                return value + 1;
            },
        },
        [comparatorFilterParams.lessThan]: {
            queryParam: '[lte]',
            queryValue: ( value ) => {
                return value - 1;
            },
        },
    };

    return comparatorMap[comparator];
};


export const generateCorrectFilterKey = ( filter, column ) => {
    return filter.customQuery ?
        `${column}${filter.customQuery.queryParam || ''}` :
        camelCase( column );
};

export const generateCorrectQueryParam = ( filter, column ) => {
    return filter.customQuery ?
        filter.customQuery.value : filterSchemaFormatter( camelCase( column ), filter.values );
};

export const clearAllFilters = ( api ) => {
    api.setFilterModel( null );
    api.onFilterChanged();
};

export const clearAllSorting = ( api ) => {
    api.setSortModel( null );
    api.onSortChanged();
};

export const clearFiltersAndSorting = ( api ) => {
    clearAllFilters( api );
    clearAllSorting( api );
};
